<div class="sppSlideToggleContainer"
     (keydown.space)="onKeyboardToggle($event)"
     [class.checked]="value === true"
     [class.unchecked]="value === false"
     [class.indeterminate]="value === null">
    <div class="sppSlideToggleThumbContainer"
         [style.width]="(containerCssWidth$ | async)"
         [class.sppSlideToggleThumbContainer--dragging]="(isDragActive$ | async) === true"
    >
        <div class="sppSlideToggleThumb"
             role="switch"
             (keyup.space)="onKeyboardToggle($event)"
             (commonDrag)="onDrag($event)"
             (commonDragEnd)="onDragEnd()"
             (commonDragStart)="onDragStart()"
        >
            <span class="icon-shut sppSlideToggleThumbIcon sppSlideToggleThumbIcon--unchecked"></span>
            <span class="icon-checkmark sppSlideToggleThumbIcon sppSlideToggleThumbIcon--checked"></span>
        </div>
    </div>
    <div class="sppSlideToggleBar" #toggleBar></div>
</div>
<ng-content></ng-content>
